module.exports = __webpack_public_path__ + "static/media/services4.801e2eb6.png";